import { Stack } from '@mui/material';

import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';

export function EncounterContactsFormFields() {
  return (
    <>
      <Stack gap={2}>
        <BlockValueTemplateField fieldName="config.encounterId" label="Encounter ID" required />
      </Stack>
    </>
  );
}
